import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const ThumbsUp = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="thumbs up icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M8.40434 9.40503L13.663 2.44598C13.8752 2.1651 14.2069 2 14.559 2C15.2904 1.99999 15.8267 2.68806 15.648 3.39735L14.3114 8.70391C14.1529 9.33297 14.6261 9.94406 15.2748 9.94815L19.5262 9.97494C21.5183 9.9875 22.9451 11.9024 22.3873 13.8149L20.42 20.56C20.1711 21.4133 19.3889 22 18.5 22H10C8.89543 22 8 21.1046 8 20V10.6108C8 10.1756 8.14196 9.75225 8.40434 9.40503Z"
    />
    <path
      className={pathClass}
      d="M3 9.99998C2.44772 9.99998 2 10.4477 2 11V21C2 21.5523 2.44772 22 3 22H5C5.55228 22 6 21.5523 6 21V11C6 10.4477 5.55228 9.99998 5 9.99998H3Z"
    />
  </svg>
)
